<template>
  <div class="staff-management">
    <basiCcontainer>
      <template #head>
        <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs-flow">
          <el-tab-pane label="员工" name="1"></el-tab-pane>
          <el-tab-pane label="部门" name="2"></el-tab-pane>
        </el-tabs>
      </template>
      <department
        ref="department"
        v-show="activeName == '2'"
        @complete="complete"
        @delDepartment="complete"
        @handleAddDepartment="handleAddDepartment"
        @handleUpdateDepartment="handleUpdateDepartment"
      />
      <div class="yg-style" v-if="activeName == '1'">
        <div class="slecle-department-tree" v-loading="treeLoading">
          <div class="search-input">
            <el-input prefix-icon="icon iconfont iconicon_search1" size="mini" placeholder="搜索部门名称" clearable v-model="filterText"> </el-input>
            <wf-button icon="icon iconfont iconicon_enlarge" @click="handleAddDepartment" v-permission="'部门管理-新增部门'" style="margin-left: 8px;"></wf-button>
          </div>
          <div class="treeLeft">
            <el-aside width="100%">
              <el-tree ref="tree" v-if="!treeLoading" :default-expanded-keys="expandedKeys" :current-node-key="currentnodekey" @node-click="handleNodeClick" :data="treeDataset" node-key="depart_id" :props="propsNode" highlight-current :filter-node-method="filterNode">
                <!-- <span slot-scope="{ node, data }">{{node.label}}</span> -->
                <toolTip  :title="node.label" slot-scope="{ node, data }" maxWidth="auto">{{node.label}}</toolTip>
              </el-tree>
            </el-aside>
          </div>
        </div>
        <div class="yg-style-right">
          <commonTable
            tableHead="staff"
            :config="{ nothing }"
            @button-click="addStaff"
            :apiUrl="{ url: 'staffManagement', methods: 'getStaffIndex' }"
            ref="commonTable"
            rowKey="job_number"
            :params="ruleForm"
            @handleSelectionChange="handleSelectionChange"
            :selection="true"
            :tipShow="false"
            :verifyRemark="true"
            :popover="false"
          >
            <template #table_head>
              <div class="search-table">
                <div class="search-table-tip" v-if="departmentInfo.depart_id">
                  <p>
                    <span class="name">{{ departmentInfo.name }}</span>
                    <span class="num">{{ `(${ departmentInfo.all_number_of_employees })` }}</span>
                    <!-- <span>共{{ departmentInfo.all_number_of_employees }}人</span>
                    <span>|</span> -->
                  </p>
                  <div class="search-table-right">
                    <span v-if="hasAdministrators" class="leader">负责人：{{ departmentInfo.department_administrators ? departmentInfo.department_administrators.map((res) => res.user.realname).join(",") : "" }}</span>
                    <span v-if="hasAdministrators" class="line"></span>
                    <el-tooltip effect="dark" content="部门设置" placement="bottom" v-permission="'部门管理-更新部门'">
                      <i class="icon iconfont iconicon_setting_project activeIconHover" @click="departmentSetting"></i>
                    </el-tooltip>
                  </div>
                </div>
                <div class="search-table-tip" v-else>
                  <p>
                    <span class="name">所有部门</span>
                    <span class="num">{{ `(${ number_of_employees })` }}</span>
                  </p>
                </div>
                <div class="search-table-tool">
                  <div class="btns">
                    <wf-button
                      type="primary"
                      style="margin-right: 12px"
                      :icon="'icon iconfont iconicon_enlarge'"
                      @click="addStaff"
                      v-permission="'用户管理-新增员工'"
                    >添加员工</wf-button>
                    <wf-button
                      type="primary"
                      plain
                      :disabled="selectionArr.length === 0"
                      :icon="'icon iconfont iconicon_adjusting_departments'"
                      @click="adjustmentCheck"
                      v-permission="'部门管理-更换员工部门'"
                    >调整部门</wf-button>
                  </div>
                  <el-input prefix-icon="iconfont iconicon_search1" @input="searchChange" class="fliter-input" v-model="ruleForm.keyword" placeholder="搜索员工名称/工号/手机号/邮箱" clearable @keyup.enter.native="init"></el-input>
                </div>
              </div>
            </template>
            <template slot="depart_id" slot-scope="scope">
              <span>{{ scope.data.department ? scope.data.department.name : "-" }}</span>
            </template>
            <template slot="usertype" slot-scope="scope">
              <span>{{ typeList[scope.data.usertype] }}</span>
            </template>
            <template slot="is_secret" slot-scope="scope">
              <span>{{ scope.data.is_secret > 0 ? "是" : "否" }}</span>
            </template>
            <template slot="job_title" slot-scope="scope">
              <span>{{ scope.data.job.job_name }}</span>
            </template>
            <template slot="realname" slot-scope="scope">
              <div class="real-name-style" @click="satffDetail(scope.data)">
                <Myavatar :userName="scope.data.realname" width="28px" height="28px" :imgUrl="scope.data.user_avatar">{{ scope.data.realname }}</Myavatar>
              </div>
            </template>
            <template slot="verifyRemark" slot-scope="scope" :verifyRemark="$permission(['用户管理-更新员工', '用户管理-删除员工'])">
              <el-dropdown trigger="click" @command="handleCommand($event, scope.data)" placement="bottom">
                <i class="icon iconfont iconicon_more_task1 tableIconHover"></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    icon="icon iconfont iconicon_input"
                    command="edit"
                    v-permission="'用户管理-更新员工'"
                  >
                    编辑信息
                  </el-dropdown-item>
                  <el-dropdown-item
                    class="warning"
                    icon="icon iconfont iconicon_leave_management"
                    command="resign"
                    v-permission="'用户管理-办理离职'"
                  >
                    办理离职
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <!-- <span @click="delStaff(scope.data)" v-permission="'用户管理-删除员工'">删除</span> -->
            </template>
          </commonTable>
        </div>
      </div>
    </basiCcontainer>

    <!-- 员工弹窗 -->
    <Staff-dialog
      v-if="staffDialogVisible"
      :dialogShow="staffDialogVisible"
      :dataset="dataset"
      :isEdit="isEditStaff"
      @complete="complete"
      @handleClose="handleClose('staffDialogVisible')"
    ></Staff-dialog>

    <!-- 部门弹窗 -->
    <Department-dialog
      v-if="departmentDialogVisible"
      :dialogShow="departmentDialogVisible"
      :isEdit="isEdit"
      :departmentInfo="departmentInfo"
      @complete="complete"
      @handleClose="handleClose('departmentDialogVisible')"
    ></Department-dialog>

    <!-- 调整部门弹窗 -->
    <el-dialog
      width="368px"
      title="选择部门"
      class="select-depart-dialog"
      :visible.sync="selectDeparVisible"
      :append-to-body="true"
    >
      <el-form :hide-required-asterisk="true" size="mini" ref="ruleForm" @submit.native.prevent>
        <el-form-item prop="roleName">
          <!-- <el-cascader v-if="selectDeparVisible" :props="props" v-model="ruleForm.departments_id" :options="options" clearable @change="changeValue"></el-cascader> -->
          <el-cascader v-if="selectDeparVisible" :props="props" v-model="ruleForm.departments_id" clearable @change="changeValue"></el-cascader>
        </el-form-item>
      </el-form>
      <div class="select-depart-dialog-footer">
        <span class="cancel text-btn-active" @click="selectDeparVisible = false">取消</span>
        <wf-button type="primary" :disabled="ruleForm.departments_id.length === 0" @click="adjustment">确定</wf-button>
      </div>
    </el-dialog>

    <!-- 办理离职弹窗 -->
    <Leave-dialog
      ref="leaveDialog"
      :dialogShow="leaveVisibile"
      :dataset="dataset"
      @handleClose="leaveVisibile = false"
      @handleSuccess="complete"
    ></Leave-dialog>

    <!-- <el-dialog title="新增员工信息" :visible.sync="dialogVisible" width="30%">
    </el-dialog> -->
    <!-- <el-drawer title="添加员工" :wrapperClosable="false" :append-to-body="true" size="500px" :visible.sync="dialogVisible">
      <staffDialog @cancel="dialogVisible = false" :visible="dialogVisible" @complete="complete" />
    </el-drawer> -->
    <!-- <el-drawer title="员工信息修改" :visible.sync="EditdialogVisible" :wrapperClosable="false" :append-to-body="true" size="500px">
      <editSatffDialog @cancel="EditdialogVisible = false" v-if="EditdialogVisible" :visible="EditdialogVisible" :dataset="dataset" @complete="complete" />
    </el-drawer> -->

    <!-- <el-drawer title="新建部门" :visible.sync="addDepartmentVisible" :wrapperClosable="false" :append-to-body="true" size="500px">
      <addDepartment @cancel="addDepartmentVisible = false" :visible="addDepartmentVisible" :isEdit="false" :isParent="true" @complete="complete" :dataset="{}" />
    </el-drawer> -->
  </div>
</template>

<script>
import api from "@/services/api/staffManagement/staffManagement";
import deparApi from "@/services/api/department/department";
import Myavatar from "@/components/avatar";
// import staffDialog from "./staffDialog";
import editSatffDialog from "./editSatffDialog";
import addDepartment from "../department/addDialog";
import department from "../department";
import { mapActions, mapState, mapMutations } from "vuex";

import StaffDialog from './components/staffDialog.vue'
import DepartmentDialog from './components/departmentDialog.vue'
import LeaveDialog from './components/leaveDialog.vue'

export default {
  components: {
    Myavatar,
    // staffDialog,
    editSatffDialog,
    addDepartment,
    department,

    StaffDialog,
    DepartmentDialog,
    LeaveDialog
  },
  computed: {
    // 是否有负责人
    hasAdministrators() {
      return this.departmentInfo.department_administrators ? this.departmentInfo.department_administrators.length : false
    }
  },
  data() {
    return {
      dialogVisible: false,
      EditdialogVisible: false,
      selectDeparVisible: false,
      addDepartmentVisible: false,
      treeLoading: false,
      ruleForm: {
        keyword: "",
        departments_id: "",
        working_type: "在职",
      },
      options: [],
      dataset: {},
      currentnodekey: 0,
      filterText: "",
      props: {
        lazy: true,
        value: "depart_id",
        label: "name",
        checkStrictly: true,
        emitPath: true,
        lazyLoad(node, resolve) {
          const { data } = node;
          deparApi.getDepartmentIndex({ pid: data ? data.depart_id : 0, level: 1 }).then((res) => {
            let tree = (dataset) => {
              dataset.map((item) => {
                if (item.children && item.children.data) {
                  item.children = item.children.data;
                } else {
                  return;
                }
                if (item.children && item.children.length > 0) {
                  tree(item.children);
                }
              });
            };
            tree(res.data);
            res.data.map((res) => {
              res.leaf = !(res.children_amount > 0);
            });
            resolve(res.data);
          });
        },
      },
      departmentInfo: {},
      propsNode: {
        label: "name",
      },
      typeList: { 0: "默认没分配角色", 1: "普通员工", 2: "主管", 3: "经理", 4: "总监", 5: "总裁", 7: "CEO", 10: "管理员" },
      expandedKeys: [],
      selectionArr: [],
      treeDataset: [],
      number_of_employees: 0,
      activeName: "1",
      timer: "",
      nothing: {
        tip: "暂无员工信息，快去添加员工吧",
        type: "img_add_task",
        btnText: "添加员工",
        permission: "",
      },

      isEditStaff: false, //是否处于员工信息编辑状态
      staffDialogVisible: false, // 员工信息弹窗开关
      departmentDialogVisible: false, // 部门弹窗开关
      isEdit: false, // 是否处于编辑状态
      leaveVisibile: false, // 离职弹窗开关
    };
  },
  mounted() {
    this.getTreeData();
    this.init();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val.replace(/\s+/g, ""));
    },
    activeName() {
      if (this.activeName == 1) {
        this.getTreeData();
        this.init();
      }
    },
  },
  methods: {
    complete(parent_id, isParent, noChildrenReload) {
      this.staffDialogVisible = false
      this.departmentDialogVisible = false;
      if (this.activeName === '2' && !noChildrenReload) {
        this.$refs.department.complete(parent_id, isParent)
        return
      }
      this.dialogVisible = false;
      this.EditdialogVisible = false;
      this.selectDeparVisible = false;
      this.addDepartmentVisible = false;
      this.leaveVisibile = false;
      this.init();
    },
    async init() {
      await this.getTreeData(true, this.currentnodekey);
      this.getNumberOfEmployees();
      this.$refs.commonTable.initQuery();
    },
    getDepartment() {
      deparApi.getDepartmentIndex({ pid: 0, level: 1 }).then((res) => {
        this.options = JSON.parse(JSON.stringify(res.data));
      });
    },
    changeValue(e) {
      this.ruleForm.departments_id = JSON.parse(JSON.stringify(e));
    },
    addStaff() {
      // this.dialogVisible = true;
      this.isEditStaff = false
      this.staffDialogVisible = true
    },
    handleCommand(command, data) {
      if (command === 'edit') {
        // 编辑员工信息
        this.editStaff(data)
      } else if (command === 'resign') {
        // 办理离职
        this.leaveStaff(data)
      }
    },
    editStaff(data) {
      this.dataset = JSON.parse(JSON.stringify(data));
      // this.EditdialogVisible = true;
      this.isEditStaff = true
      this.staffDialogVisible = true
    },
    leaveStaff(data) {
      this.dataset = JSON.parse(JSON.stringify(data));
      if (data.uncompleted_number_of_tasks === 0) {
        // 未完成任务数为0，可直接离职
        this.$wfAlert('', `确认对 ${ data.realname } 办理离职？`, '', '确定').then(() => {
          this.$refs.leaveDialog.handleResign()
        }).catch(() => {
          console.log('执行异常')
          next(false)
        })
      } else {
        this.leaveVisibile = true
      }
    },
    async delStaff(data) {
      await this.$wfAlert('warning', `确定删除员工${data.realname}?`)
      await api.deleteStaffr({ uid: data.uid })
      this.init()
      this.$message({
        type: "success",
        message: "删除成功!",
      })
    },
    satffDetail(data) {
      console.log("asdasdsad");
      data.check && this.$router.push("staffManagementDetail?uid=" + data.uid);
    },
    getTreeData(need, depart_id) {
      this.treeLoading = true;
      return deparApi
        .getDepartmentIndex({ pid: 0, level: 10 })
        .then((res) => {
          // this.expandedKeys = res.data.map(item => item.depart_id)
          this.expandedKeys = [0];
          let tree = (dataset) => {
            dataset.map((item) => {
              if (item.children && item.children.data) {
                item.children = item.children.data;
              } else {
                return;
              }
              if (item.children && item.children.length > 0) {
                tree(item.children);
              }
            });
          };
          tree(res.data);
          this.treeDataset = [
            {
              name: require("@config/projectConfig").companyName,
              depart_id: 0,
              children: res.data,
            },
          ];
          this.treeLoading = false;
          if (need) {
            this.currentnodekey = depart_id;
            this.handleNodeClick(this.getTreeItem(this.treeDataset, depart_id));
          }
        })
        .catch((err) => {
          this.treeLoading = false;
        });
    },
    treeLazyLoad(node, resolve) {
      const { data } = node;
      deparApi.getDepartmentIndex({ pid: data ? data.depart_id : 0, level: 10 }).then((res) => {
        res.data.map((item) => {
          item.leaf = !(item.children_amount > 0);
          item.children = item.children.data;
        });
        if (!data) {
          this.expandedKeys = res.data.map((item) => item.depart_id);
        }
        resolve(res.data);
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleNodeClick(data, checked, indeterminate) {
      this.departmentInfo = data;
      this.ruleForm.departments_id = data.depart_id || "";
      this.$refs.commonTable.initQuery();
    },
    adjustment() {
      if (!this.ruleForm.departments_id) {
        this.$message({
          type: "error",
          message: "请选择调整部门",
        });
        return;
      }
      let params = {
        depart_id: this.ruleForm.departments_id[this.ruleForm.departments_id.length - 1],
        uids: this.selectionArr,
      };
      deparApi.changeEmployeesDepartment(params).then(async (res) => {
        this.$message({
          type: "success",
          message: "部门调整成功！",
        });
        this.selectDeparVisible = false;
        await this.getTreeData(true, params.depart_id);
      });
    },
    getTreeItem(treeDataset, depart_id) {
      for (let i = 0; i < treeDataset.length; i++) {
        if (treeDataset[i].depart_id === depart_id) {
          return treeDataset[i];
        } else if (treeDataset[i].children && treeDataset[i].children.length > 0) {
          let item = this.getTreeItem(treeDataset[i].children, depart_id);
          if (item) {
            return item;
          }
        }
      }
    },
    adjustmentCheck() {
      if (this.selectionArr.length === 0) {
        this.$message({
          message: "请勾选员工再进行操作",
          type: "warning",
        });
      } else {
        this.ruleForm.departments_id = "";
        this.selectDeparVisible = true;
      }
    },
    handleSelectionChange(val) {
      if (val.length > 0) {
        this.selectionArr = val.map((res) => res.uid);
      } else {
        this.selectionArr = [];
      }
      // console.log(this.selectionArr, 1111)
    },
    getNumberOfEmployees() {
      api.getNumberOfEmployees().then((res) => {
        this.number_of_employees = res.number_of_employees;
      });
    },
    handleClick(val) {
      if (val.name == 2) {
        this.$refs.department.init();
      }
    },
    searchChange() {
      clearInterval(this.timer);
      this.timer = "";
      this.timer = setInterval(() => {
        this.$refs.commonTable.initQuery();
        clearInterval(this.timer);
        this.timer = "";
      }, 300);
    },
    departmentSetting() {
      this.isEdit = true
      this.departmentDialogVisible = true
      // this.$refs.department.editDepartment(this.departmentInfo);
    },
    handleAddDepartment() {
      this.isEdit = false
      this.departmentInfo = {}
      this.departmentDialogVisible = true
    },
    handleUpdateDepartment(data) {
      this.isEdit = true
      this.departmentInfo = data
      this.departmentDialogVisible = true
    },

    handleClose(val) {
      this[val] = false
    }
  },
};
</script>
<style lang="scss" src="./style.scss"></style>
